import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children, isAllowed, redirectTo, ...props }) => {
  return isAllowed ? children : <Navigate to={redirectTo || "/login"} />;
};

export default PrivateRoute;
